import * as React from 'react';
import { GMap } from 'primereact/gmap';
import offline from '../../assets/auto-offline.svg';
import online from '../../assets/auto-online.svg';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap'

export default function PositionMap({
    position,
    onMapReady,
    gisDeviceStatus
}) {
    if (!position) return null;

    const google = window.google;

    function getMapsData(position) {
        if (!position) return null;

        const options = {
            center: { lat: position.latitude, lng: position.longitude },
            zoom: 16,
            subtree: false
        };
        const overlays = [
            new google.maps.Marker({
                position: { lat: position.latitude, lng: position.longitude },
                title: 'car',
                icon: gisDeviceStatus === 'online' ? online : offline
            })
        ];

        return { options, overlays };
    }

    const mapData = getMapsData(position);

    return (
        <Card className="card-box mb-2 mt-2">
            <CardHeader>
                <h4 className="font-size-lg mb-0 py-0 font-weight-bold">
                    Posizione del veicolo sulla mappa
                </h4>
            </CardHeader>
            <CardBody className="px-2 pt-3">

                <GMap
                    onMapReady={onMapReady}
                    overlays={mapData.overlays}
                    options={mapData.options}
                    style={{ width: '100%', minHeight: '420px' }}
                />
            </CardBody>
        </Card>
    );
}
